import React from 'react'
import { AnimatedLogo } from '../widgets'
import { VERSION } from '../../lib/constants'

class Brand extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      visible: true
    }
  }

  hide = () => this.setState({ visible: false })

  render() {
    if (!this.state.visible) return null

    return (
      <li className='px-nav-box p-a-2 b-b-1'>
        <button type='button' className='close' onClick={this.hide}>
          <span>×</span>
        </button>
        <div className='pull-xs-left m-r-3'>
          <AnimatedLogo animation='dash' strokeColor='red' color='white' size={36}/>
        </div>
        <div style={{ color: '#35aba1' }}>
          <div className='font-size-15'><strong>ANIOT</strong></div>
          <div className='font-size-12'>version: {VERSION}</div>
        </div>
      </li>
    )
  }
}

export default Brand



// WEBPACK FOOTER //
// ./src/components/nav/Brand.js